import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * @typedef Props
 * @prop {() => void} [onChange]
 * @prop {boolean} [checked]
 * @prop {string} [className]
 * @prop {boolean} [disabled]
 * @prop {string} [id]
 * @prop {string} [onLabel]
 * @prop {string} [offLabel]
 * @prop {string} [value]
 * @prop {boolean} [hideLabels]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifToggleSwitch = (props) => {
  const {
    className = '',
    disabled = false,
    checked = false,
    onChange = null,
    id = '',
    value = '',
    hideLabels = false,
    onLabel = 'On',
    offLabel = 'Off',
    ...other
  } = props;
  const classes = classNames({
    'motif-toggle-switch-wrapper': true,
    'motif-toggle-switch-disabled': disabled,
    'motif-toggle-switch-checked': checked,
    'motif-toggle-switch-hidden-labels': hideLabels,
    [className]: true
  });

  return (
    <div className={classes} data-motif-toggle-switch>
      <span className="motif-toggle-switch-off-text" aria-label={offLabel}>
        {offLabel}
      </span>
      <label className="motif-toggle-switch" htmlFor={id} aria-live="assertive">
        <input
          {...other}
          id={id}
          type="checkbox"
          aria-label={`${offLabel}-${onLabel}`}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          name={name}
          value={value || checked}
        />
        <span className="motif-toggle-switch-slider" />
        </label>
      <span className="motif-toggle-switch-on-text" aria-label={onLabel}>
        {onLabel}
      </span>
    </div>
  );
};

MotifToggleSwitch.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  hideLabels: PropTypes.bool,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string
};

export { MotifToggleSwitch };
